export const GET_DOC_REVIEW = "GET_DOC_REVIEW";
export const GET_DOC_REVIEW_SUCCESS = "GET_DOC_REVIEW_SUCCESS";
export const GET_DOC_REVIEW_FAILED = "GET_DOC_REVIEW_FAILED";
export const GET_DOC_REVIEW_RESET = "GET_DOC_REVIEW_RESET";

